import TargetsProductFilters from './FiltersPage';

export default TargetsProductFilters;
